export enum CLOSE_OPTION {
  ICON = 'ICON',
  LINK = 'LINK',
}

/**
 * These events are dispatched on the window
 */
export enum UcV3Event {
  /**
   * The UC_UI_CMP_EVENT event is triggered by the most important actions that can be performed in the CMP, enabling you to listen to user interactions.
   * The structure of the detail (event.detail) is the following:
   * { abTestVariant: undefined, source: "second", type: "CMP_SHOWN" }
   *
   * `abTestVariant` - String that identifies the A/B test variant currently in use, if none, the value will be undefined.
   * `source` - Where the event was triggered, it can be:
   *   - "none" - Triggered when the CMP was not being shown
   *   - "button" - Triggered when the Privacy Button was being shown
   *   - "first" - Triggered when the First Layer was being shown
   *   - "second" - Triggered when the Second Layer was being shown
   *   - "embeddings" - Triggers when the Embeddings were being shown
   *   - "__ucCmp" - Triggered by the __ucCmp window object
   *
   * `type`:
   *   - CMP_SHOWN - Triggered when the CMP is shown
   *   - ACCEPT_ALL - Triggered by clicking the Accept All button
   *   - DENY_ALL - Triggered by clicking the Deny All button
   *   - SAVE - Triggered by clicking the Save button
   *   - MORE_INFORMATION_LINK - Triggered by clicking the More Information button
   *   - IMPRINT_LINK - Triggered by clicking the Imprint link
   *   - PRIVACY_POLICY_LINK - Triggered by clicking the Privacy Policy link
   */
  CMPEvent = 'UC_UI_CMP_EVENT',
  /**
   * This event gets triggered when consent changes.
   * The event.detail that is returned will contain a ConsentDetails object
   */
  Consent = 'UC_CONSENT',
  /**
   * This is an example of how to wait for the CMP to initialise before executing code
   */
  Initialized = 'UC_UI_INITIALIZED',
  /**
   * This event gets triggered when the user:
   *   - Opens a layer
   *   - Switches from layer one to layer two
   *   - Switches from layer two to layer one
   *   - Closes all layers
   *
   * The event also holds additional information with more details about the user behaviour. It is possible to know the current and previous layer displayed to the user.
   *
   * Possible values for the additional data:
   *   - FIRST_LAYER - The first layer
   *   - NONE - No layer is/was shown
   *   - PRIVACY_BUTTON - The Privacy Button
   *   - SECOND_LAYER - The second Layer
   */
  ViewChanged = 'UC_UI_VIEW_CHANGED',
}

export enum UCCMPEventType {
  CMP_SHOWN = 'CMP_SHOWN',
  ACCEPT_ALL = 'ACCEPT_ALL',
  DENY_ALL = 'DENY_ALL',
  SAVE = 'SAVE',
  MORE_INFORMATION_LINK = 'MORE_INFORMATION_LINK',
  IMPRINT_LINK = 'IMPRINT_LINK',
  PRIVACY_POLICY_LINK = 'PRIVACY_POLICY_LINK',
}
